<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header p-2">
              <h6 class="modal-title">
                <template v-if="newFav">{{favInfo.type == 'Saved Search'?$t('Add Saved Search'):$t('Add Bookmark')}}</template>
                <template v-else>{{favInfo.type == 'Saved Search'?$t('Edit Saved Search'):$t('Edit Bookmark')}}</template>
              </h6>
              <button class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
                <span aria-hidden="true">
                    <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                    </cancel-icon>
                </span>
              </button>
            </div>
            <div class="modal-body">
                <div class="h-100" style="overflow:auto" ref="generalTab">
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                        <div>
                            <label>{{$t('Name')}}</label>
                        </div>
                        <input v-model="bookmarkName" ref="fieldbookmarkName" placeholder="Enter name" type="text"  class="bg-transparent rounded text-light input-text-field add-border"/>
                    </div>
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;">
                        <div>
                            <label>{{$t('Thumbnail')}}</label>
                        </div>
                        <div style="display: flex;justify-content: center;">
                            <div class="profile-image-upload-wrapper">
                                <div class="profile-image-display">
                                    <img v-if="imageType == 'image'" :src="getProxyConvertedURL(postData.cover_photo)" style="height:100%;width:100%">
                                    <svg v-else-if="imageType == null" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16" style="height: 100px !important;width: 100% !important;color: #4e4e4e;padding:0px 7px">
                                      <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"/>
                                      <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z"/>
                                    </svg>
                                    <canvas v-else-if="imageType == 'canvas'" ref="preferenceUploadCanvas" style="border-radius:5px;" id="canvas"></canvas>
                                </div>
                                <div class="upload-profile-image-button" :style="imageType != null?'display: flex;width: 185px;':''">
                                    <div class="btn-wrapper cover-image">
                                    <button v-if="imageType == null"  class="btn btn-outline-primary cover-image-change">{{$t('Upload')}}</button>
                                    <button v-else class="btn btn-outline-primary cover-image-change">{{$t('Change')}}</button>
                                    <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                                    <input type="file"
                                        id="img-input"
                                        ref="uploadFile"
                                        @change="uploadProfileImage($event)"
                                        accept="image/*"></div>
                                    </div>

                                    <div v-if="imageType != null" style="position:relative;" class="btn-wrapper mb-0">
                                      <button class="btn btn-outline-secondary" @click="removeCoverImage()">{{$t('Remove')}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="common-input-field" style="margin-inline-start: 2%;margin-top:7px;display:flex;flex-direction:column">
                      <div>
                        <label>{{$t('Display Area')}}</label>
                      </div>
                      <div class="d-inline-flex w-100 mt-2" style="flex-direction:column">
                        <div class="custom-control custom-switch w-100 mb-2">
                          <input
                              v-on:click="showInBookmarksbar = !showInBookmarksbar"
                              type="checkbox"
                              class="custom-control-input"
                              id="DAM-show_in_bookmarks_bar"
                              :checked="showInBookmarksbar"/>
                          <label class="custom-control-label w-100" for="DAM-show_in_bookmarks_bar">Show in Bookmarks Bar</label>
                        </div>
                        <div class="custom-control custom-switch w-100">
                          <input
                              v-on:click="showInQuickAccessPanel = !showInQuickAccessPanel"
                              type="checkbox"
                              class="custom-control-input"
                              id="DAM-show_in_quick_access_panel"
                              :checked="showInQuickAccessPanel"/>
                          <label class="custom-control-label w-100" for="DAM-show_in_quick_access_panel">Show in Quick Access Panel</label>
                        </div>
                    </div>
                    </div>
              </div>
            </div>
            <div class="modal-footer p-0 primary-btn-style" style="padding-inline-end:10px !important;">
              <button class="btn btn-outline-secondary" data-dismiss="modal" @click.prevent="closeDialog()">{{$t('Cancel')}}</button>
              <button class="btn btn-outline-primary" @click.prevent="updatebookmarkName()">
                {{$t('Save')}}
              </button>
            </div>
          </div>
        </div>
    </div>
</template>
    
    
  <script>
    import {mapActions} from "vuex";
    import CancelIcon from "../core/InlineCancelField.vue";
    import Utils from "../../components.utils.js";
    
    export default {
      props:["favInfo", "newFav"],
      data: () => ({
        dialog: true,
        bookmarkName:"",
        imageType:null,
        MAX_WIDTH: 320,
        MAX_HEIGHT: 180,
        MIME_TYPE: "image/jpeg",
        QUALITY: 0.7,
        uploadedImage:"",
        PROFILE_IMAGE_ALLOWED_WIDTH:128,
        showInBookmarksbar:true,
        showInQuickAccessPanel:false,
        removeCoverImageClicked:false
      }),
      components:{
        'cancel-icon':CancelIcon
      },
      methods:{
          getProxyConvertedURL(url){
              return Utils.convertToLoginIPDomainName(url);
          },
          closeDialog(){
              this.bookmarkName = "";
              this.$emit("close");
          },
          uploadProfileImage(ev){
            this.imageType = "canvas";
            let file = ev.target.files[0]; // get the file
            let blobURL = URL.createObjectURL(file);
            this.drawImage(blobURL,false)
          },

        drawImage(blobURL){
            this.imageType = "canvas";
            let img = new Image();
            img.src = blobURL;
            img.onerror = ()=> {
                URL.revokeObjectURL(this.src);
                // Handle the failure properly
                alert.log("Could not able to load selected image.");
            };
            img.onload = ()=> {
                URL.revokeObjectURL(this.src);
                let wrh = img.naturalWidth / img.naturalHeight;
                let calculatedImageHeightAsPerAspectRatio = this.PROFILE_IMAGE_ALLOWED_WIDTH / wrh;
                let canvas = this.$refs.preferenceUploadCanvas;
                canvas.width = this.PROFILE_IMAGE_ALLOWED_WIDTH;
                canvas.height = calculatedImageHeightAsPerAspectRatio
                canvas.getContext("2d").drawImage(img, 0, 0, this.PROFILE_IMAGE_ALLOWED_WIDTH, calculatedImageHeightAsPerAspectRatio);
                this.$nextTick(()=>{
                    this.uploadedImage = canvas.toDataURL();
                });
            };
        },
        removeCoverImage(){
          this.uploadedImage = "";
          this.imageType = null;
          this.removeCoverImageClicked = true;
        },
          updatebookmarkName() {
            this.bookmarkName = this.bookmarkName.trim();
            if (this.bookmarkName.trim().length == 0) {
              alert("Please add a valid name.");
              return;
            }
            if (this.newFav) {
              let payload = { name: this.bookmarkName, url: this.$route.fullPath, type: this.favInfo.type };
              if (this.uploadedImage) {
                payload["cover_photo"] = this.uploadedImage;
              }
              if (this.showInBookmarksbar) {
                payload["show_in_bookmark_bar"] = true;
              }else{
                payload["show_in_bookmark_bar"] = false;
              } 
              if(this.showInQuickAccessPanel) {
                payload["show_in_quick_access_panel"] = true;
              }else{
                payload["show_in_quick_access_panel"] = false;
              }
              this.addNewFavorite(payload).then(data => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                  this.$toast.success(data.message);
                  this.closeDialog();
                } else {
                  this.$toast.error(data.message);
                }
              });
            } else {
              if (this.bookmarkName.length != 0) {
                let payload = { _id: this.favInfo._id, params: { _id: this.favInfo._id } };
                if (this.bookmarkName.trim() != this.favInfo.name.trim()) {
                  payload['name'] = this.bookmarkName;
                }
                if(this.removeCoverImageClicked){
                  payload['cover_photo'] = '';
                }else{
                  if(this.uploadedImage.length){
                    payload['cover_photo'] = this.uploadedImage;
                  }else if(this.favInfo.cover_photo && this.favInfo.cover_photo.length){
                    delete payload['cover_photo']
                  }else {
                    delete payload['cover_photo']; // Remove cover_photo from payload if it is not changed
                  }
                }
                if (this.showInBookmarksbar) {
                  payload["show_in_bookmark_bar"] = true;
                }else{
                  payload["show_in_bookmark_bar"] = false;
                } 
                if(this.showInQuickAccessPanel) {
                  payload["show_in_quick_access_panel"] = true;
                }else{
                  payload["show_in_quick_access_panel"] = false;
                }
                this.updateExistingFavorite(payload).then(data => {
                  if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.removeCoverImageClicked = false;
                    this.closeDialog();
                  } else {
                    this.$toast.error(data.message);
                  }
                });
              } else {
                alert("Please add a valid name.");
              }
            }
          },
          ...mapActions("favorites", ["addNewFavorite","updateExistingFavorite"]),
      },
      created(){
        if(this.favInfo){
          this.bookmarkName = this.favInfo.name
          if(this.favInfo.cover_photo){
            this.drawImage(Utils.convertToLoginIPDomainName(this.favInfo.cover_photo),true)
          }
          if(Object.keys(this.favInfo).includes('show_in_bookmark_bar')){
            this.showInBookmarksbar = this.favInfo.show_in_bookmark_bar;
          }
          if(Object.keys(this.favInfo).includes('show_in_quick_access_panel')){
            this.showInQuickAccessPanel = this.favInfo.show_in_quick_access_panel;
          }
        }  
      },
      mounted(){
        this.$refs.fieldbookmarkName.focus();
      }
    }
  </script>
    
  <style lang="scss" scoped>
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    .modal-dialog {
        max-width: 400px;
        width: 400px;
        margin: 0;
        padding: 0;
      }
      
      .modal-content {
        // height: 227px;
        height: 50%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
          background: $primary-background;
          padding: 0px;
          height:400px;
          overflow: auto;
        }
      }
    
    .modal {
      text-align: center;
      padding: 0!important;
      display:inline-flex !important;
      align-items: center;
      justify-content: center;
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 1rem 0px !important;
    }
    .modal:before {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      margin-inline-end: -4px;
    }
    .modal-dialog {
      display: inline-block;
      text-align: start;
      vertical-align: middle;
    }

    .modal:before {
      content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .border{
        border: $border-color !important;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        align-items: center;
        .modal-title{
          color:$text-color;
        }
    }
    
    .primary-btn-style{
        margin-top:1%;
        button{
            height: 35px;
            width: 75px;
            font-size:14px;
        }
    }
    
    .secondary-btn-style{
      color:$text-color;
    }
    
    .key-style {
      color: $dull-text-color;
      width: 30%;
      text-align: start;
      font-size: $input-field-and-label-font-size;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    
    .input-fields {
      border: none !important;
      border-bottom: 1px solid $active-blue !important;
      height:30px;
    }
    
    .input-fields:focus {
      outline: unset;
      box-shadow:none;
    }
    .close-icon:hover{
      background: $icon-hover;
      border-radius: 20px;
    }
    .config-desc{
      color: $dull-text-color;
      font-size:12px;
    }

    .common-input-field{
        margin-inline-start: 3%;
        display: inline-block;
        width: 96%;
        justify-content: space-between;
        display: inline-block;
        padding: 9px;
        border-radius: 4px;
        background: $primary-background;
        border: $secondary-border-color !important;
        label{
            width: 30%;
            color: $secondary-text-color;
            word-break: break-word;
        }
        input{
            flex:1;
        }
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }
    .add-border{
        border: $border-color;
    }

    .profile-image-upload-wrapper{
        // padding:30px;
        display: flex;
        align-items: center;
        .profile-image-display{
            border: 1px solid #3a3a3a;
            border-radius: 10px;
            margin: auto;
            justify-content: center;
            display: flex;
            .canvas{
                    height: 100%;
                    width: 100%;
                    border-radius: 5px;
            }
        }
        .upload-profile-image-button{
            padding: 8px 0px;
            margin: 0 auto;
            display: flex;
            margin-inline-start: 10px;
            flex-direction: column;
            .btn-wrapper{
                // margin-bottom: 8px;
                width: 130px;
                position: relative;
                margin: auto;
                display: inline-flex;
                justify-content: center;
                margin-bottom: 10px;
                
                button{
                  width:96%;
                }
            }
        }
    }

  .cover-image:hover{
    .cover-image-change{
      color: #fff !important;
      background-color: #007bff;
      border-color: #007bff;
      border-radius:0.25rem;
    }
  }
  input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

}

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

.bigger-checkboxes {
  height: 30px;
  width: 20px;
  position:relative;
}
input[type="checkbox"]:after {
  line-height: 1.5em;
  content: "";
  display: inline-block !important;
  width: 22px !important;
  height: 21px !important;
  margin-top: 5px !important;
  margin-inline-start: -1px !important;
  border: $border-color !important;
  border-radius: 0.25em !important;
  background: $primary-background !important;
}
input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue !important;
  position: absolute !important;
  font-size: 16px !important;
  line-height: 1 !important;
  transition: all 0.2s !important;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px !important;
  padding-top: 2px !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
</style>